import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ApiService {
	constructor(private http: HttpClient) {}

	postRequest<T>(url: string, body: any, options?: any): Observable<any> {
		const fullUrl = `${environment.pathBackend}/${url}`;
		return this.http.post<T>(fullUrl, body, options);
	}

	getRequest<T>(url: string, options?: any): Observable<any> {
		const fullUrl = `${environment.pathBackend}/${url}`;
		return this.http.get<T>(fullUrl, options);
	}

	postFileRequest<T>(url: string, formData: FormData): Observable<T> {
		return this.http.post<T>(`${environment.pathBackend}/${url}`, formData);
	}

	getRequestWithParams<T>(url: string, params: HttpParams): Observable<T> {
		return this.http.get<T>(`${environment.pathBackend}/${url}`, { params });
	}
}
